<template lang="pug">
v-dialog(v-model="dialogVisible" width="500" )
    v-card
      v-card-title ⚠️ Atención
      v-card-text 
        h3 {{ dialogText }}
      v-card-actions
        div(v-if="okcancel")
          v-btn(@click="emitOk()") Si
          v-btn(@click="emitCancel()") No
        div(v-else)
          v-btn(@click="emitCancel()") Cerrar
</template>
    <script>
    let f_onOK = null
    let f_onCancel = null
    export default {
      props: {
      },
      data() {
        return {
          okcancel:false,
          dialogVisible: false,
          dialogText:"",
        }
      },
      methods: {
        emitOk() {
          if (f_onOK) f_onOK();
          this.dialogVisible = false;
        },
        emitCancel() {
          if (f_onCancel) f_onCancel();
          this.dialogVisible = false;
        },        
        /**
         * muestra un mensaje de si o no en pantalla
         * @param {*} text texto a mostrar
         * @param {*} onOk funcion a ejecutar si se clickea en si
         * @param {*} onCancel funcion a ejecutar si se clickea en no
         */
        show(text,onOk = null,onCancel = null) {
          f_onOK = onOk;
          f_onCancel = onCancel;
          this.okcancel = f_onOK?true:false;
          this.dialogText = text;
          this.dialogVisible = true;
        },
      },
    }
    </script>